// AI overview — async loader.
//
// Fills any .mad-search-ai container that has a (non-empty) data-query with the
// cached OpenAI summary from the secured endpoint. Idempotent + re-runnable, so
// SearchApp.js can call it again after swapping in fresh results.

function fillOverview(el, cfg) {
  var query = el.getAttribute('data-query');
  if (!query) {
    return; // Nothing to summarize yet.
  }
  if (el.getAttribute('data-ai-loaded') === '1') {
    return; // Already handled this node.
  }
  el.setAttribute('data-ai-loaded', '1');

  el.removeAttribute('hidden');
  el.classList.add('is-loading');

  var sep = cfg.endpoint.indexOf('?') === -1 ? '?' : '&';
  var url = cfg.endpoint + sep +
    's=' + encodeURIComponent(query) +
    '&lang=' + encodeURIComponent(el.getAttribute('data-lang') || '') +
    '&sources=' + encodeURIComponent(el.getAttribute('data-sources') || '') +
    '&posttypes=' + encodeURIComponent(el.getAttribute('data-posttypes') || '');

  fetch(url, {
    method: 'GET',
    headers: { 'X-WP-Nonce': cfg.nonce || '' },
    credentials: 'same-origin'
  })
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (data) {
      if (data && data.success && data.html) {
        var body = el.querySelector('.mad-search-ai__body');
        if (body) {
          body.innerHTML = data.html;
          body.removeAttribute('aria-busy');
          setupCollapse(el, body, cfg);
        }
        el.classList.remove('is-loading');
      } else {
        el.setAttribute('hidden', ''); // Nothing to show -> degrade silently.
      }
    })
    .catch(function () {
      el.setAttribute('hidden', '');
    });
}

// Collapse the summary to two lines behind a "Mehr anzeigen" toggle (mobile only;
// CSS keeps the toggle hidden on wider screens). Only shown when the text actually
// overflows so short answers stay fully visible.
function setupCollapse(el, body, cfg) {
  var text = body.querySelector('.mad-search-ai__text');
  if (!text) {
    return;
  }

  var i18n = (cfg && cfg.i18n) || {};
  var moreLabel = i18n.more || 'Mehr anzeigen';
  var lessLabel = i18n.less || 'Weniger anzeigen';

  var toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'mad-search-ai__toggle';
  toggle.textContent = moreLabel;
  toggle.setAttribute('aria-expanded', 'false');

  if (text.nextSibling) {
    body.insertBefore(toggle, text.nextSibling);
  } else {
    body.appendChild(toggle);
  }

  // Clamp first, then measure: overflow means there's more than two lines to show.
  el.classList.add('is-collapsed');
  if (text.scrollHeight - text.clientHeight > 2) {
    el.classList.add('is-collapsible');
  }

  toggle.addEventListener('click', function () {
    var collapsed = el.classList.toggle('is-collapsed');
    toggle.textContent = collapsed ? moreLabel : lessLabel;
    toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  });
}

function initAiOverview(root) {
  var cfg = window.madSearchAI;
  if (!cfg || !cfg.endpoint || typeof window.fetch !== 'function') {
    return;
  }
  var scope = root || document;
  var blocks = scope.querySelectorAll('.mad-search-ai[data-query]');
  for (var i = 0; i < blocks.length; i++) {
    fillOverview(blocks[i], cfg);
  }
}

// Exposed so the search controller can re-init after DOM swaps.
window.madSearchInitAi = initAiOverview;

if (document.readyState !== 'loading') {
  initAiOverview(document);
} else {
  document.addEventListener('DOMContentLoaded', function () { initAiOverview(document); });
}

module.exports = {};
